import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex text-center text-2xl my-4" }
const _hoisted_2 = { class: "flex" }

import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'DialogDelete',
  props: {
  showDelete: Boolean,
  header: String,
  message: String,
},
  emits: ["delete"],
  setup(__props) {

const props = __props;


const show = computed(() => {
  return props.showDelete ? true : false;
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: show.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
    modal: "",
    closable: false,
    header: __props.header,
    style: { width: '50rem' },
    breakpoints: { '1199px': '75vw', '575px': '90vw' }
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Button, {
          label: "YES",
          severity: "danger",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete', true))),
          class: "flex-1 mr-4"
        }),
        _createVNode(_component_Button, {
          label: "NO",
          severity: "success",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('delete', false))),
          class: "flex-1 ml-4"
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(__props.message), 1)
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}
}

})